import { render, staticRenderFns } from "./contentBar.vue?vue&type=template&id=4d774c8b&scoped=true"
import script from "./contentBar.vue?vue&type=script&lang=js"
export * from "./contentBar.vue?vue&type=script&lang=js"
import style0 from "./contentBar.vue?vue&type=style&index=0&id=4d774c8b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d774c8b",
  null
  
)

export default component.exports